import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import HistoryIcon from "@mui/icons-material/History";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import Icon from "@mdi/react";
import { mdiFileExcel } from "@mdi/js";

import EstudiosService from "../services/EstudiosService";
import SucursalesService from "../services/SucursalesService";
import InventariosService from "../services/InventarioService";

import {
    Grid,
    TextField,
    Select,
    MenuItem,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Typography,
    Tooltip,
    Stack,
    Box,
    IconButton,
    Checkbox,
    FormControlLabel,
    CircularProgress,
    Chip,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const setupSwalAutocomplete = ({
    inputId,
    hiddenId,
    dropdownId,
    items = [],
    initialSelectedId = null,
    onSelect = null,
    extraHiddenId = null,
}) => {
    const inputEl = document.getElementById(inputId);
    const hiddenEl = document.getElementById(hiddenId);
    const dropdownEl = document.getElementById(dropdownId);
    const extraHiddenEl = extraHiddenId ? document.getElementById(extraHiddenId) : null;

    if (!inputEl || !hiddenEl || !dropdownEl) return;

    const renderOptions = (filterQuery = "") => {
        const q = filterQuery.toLowerCase().trim();
        const matches = items.filter(a => (a.nombre || "").toLowerCase().includes(q));

        if (matches.length === 0) {
            dropdownEl.innerHTML = `
                <div style="padding:0.6vw;font-size:0.85vw;color:#94a3b8;text-align:center;">
                    No se encontraron artículos
                </div>
            `;
            return;
        }

        dropdownEl.innerHTML = matches.map(a => `
            <div class="swal-ac-item" data-id="${a.idArticulo}" data-stock="${a.stock}" data-name="${a.nombre}"
                 style="padding:0.5vw 0.8vw;cursor:pointer;font-size:0.85vw;border-bottom:1px solid #f1f5f9;transition:background 0.15s;text-align:left;"
                 onmouseover="this.style.background='#f1f5f9'" onmouseout="this.style.background='#fff'">
                <div style="font-weight:600;color:#1e293b;">${a.nombre}</div>
                <div style="font-size:0.75vw;color:#64748b;">Stock actual: ${a.stock}</div>
            </div>
        `).join("");

        dropdownEl.querySelectorAll(".swal-ac-item").forEach(item => {
            item.addEventListener("mousedown", (e) => {
                e.preventDefault();
            });
            item.addEventListener("click", (e) => {
                const target = e.currentTarget;
                const id = target.getAttribute("data-id");
                const name = target.getAttribute("data-name");
                const stock = target.getAttribute("data-stock");

                inputEl.value = name;
                hiddenEl.value = id;
                if (extraHiddenEl) extraHiddenEl.value = stock;

                dropdownEl.style.display = "none";
                if (onSelect) onSelect(id, name, stock);
            });
        });
    };

    if (initialSelectedId) {
        const initArt = items.find(a => String(a.idArticulo) === String(initialSelectedId));
        if (initArt) {
            inputEl.value = initArt.nombre;
            hiddenEl.value = initArt.idArticulo;
            if (extraHiddenEl) extraHiddenEl.value = initArt.stock;
        }
    }

    inputEl.addEventListener("focus", () => {
        renderOptions(inputEl.value);
        dropdownEl.style.display = "block";
    });

    inputEl.addEventListener("input", (e) => {
        hiddenEl.value = "";
        if (extraHiddenEl) extraHiddenEl.value = "0";

        const exactMatch = items.find(a => a.nombre.toLowerCase().trim() === e.target.value.toLowerCase().trim());
        if (exactMatch) {
            hiddenEl.value = exactMatch.idArticulo;
            if (extraHiddenEl) extraHiddenEl.value = exactMatch.stock;
            if (onSelect) onSelect(exactMatch.idArticulo, exactMatch.nombre, exactMatch.stock);
        }

        renderOptions(e.target.value);
        dropdownEl.style.display = "block";
    });

    inputEl.addEventListener("blur", () => {
        setTimeout(() => {
            dropdownEl.style.display = "none";
            if (!hiddenEl.value) {
                const typedVal = inputEl.value.toLowerCase().trim();
                const match = items.find(a => a.nombre.toLowerCase().trim() === typedVal);
                if (match) {
                    inputEl.value = match.nombre;
                    hiddenEl.value = match.idArticulo;
                    if (extraHiddenEl) extraHiddenEl.value = match.stock;
                    if (onSelect) onSelect(match.idArticulo, match.nombre, match.stock);
                } else {
                    inputEl.value = "";
                }
            }
        }, 150);
    });
};

const Inventario = () => {
    const MySwal = withReactContent(Swal);

    const usuarioString = sessionStorage.getItem("usuario");
    const currentU = usuarioString ? JSON.parse(usuarioString) : null;
    const isAdmin = currentU ? (currentU.rol === "A" || currentU.rol === "ADMIN" || currentU.rol !== "E") : false;
    const userSucursal = currentU?.sucursal || 1;

    const [loading, setLoading] = useState(true);
    const [articulos, setArticulos] = useState([]);
    const [estudios, setEstudios] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [selectedSucursal, setSelectedSucursal] = useState(isAdmin ? "todas" : userSucursal);
    const [articuloBuscar, setArticuloBuscar] = useState("");
    const [stockMinimoUmbral, setStockMinimoUmbral] = useState(5);
    const [processingAction, setProcessingAction] = useState(false);

    useEffect(() => {
        document.title = "Inventario";
    }, []);

    const loadInitialData = async () => {
        setLoading(true);
        try {
            const [resEstudios, resSucursales] = await Promise.all([
                EstudiosService.getEstudios(),
                SucursalesService.getSucursales()
            ]);

            if (resEstudios?.data?.estudios) {
                setEstudios(resEstudios.data.estudios);
            }
            if (resSucursales?.data?.sucursales) {
                setSucursales(resSucursales.data.sucursales);
            } else if (Array.isArray(resSucursales?.data)) {
                setSucursales(resSucursales.data);
            }

            await fetchInventario();
        } catch (err) {
            console.error("Error inicializando inventario:", err);
            mostrarToast("error", "Error al cargar datos del sistema");
        } finally {
            setLoading(false);
        }
    };

    const fetchInventario = async () => {
        try {
            const res = await InventariosService.getInventario(selectedSucursal);
            if (res && res.articulos) {
                setArticulos(res.articulos);
            }
        } catch (err) {
            console.error("Error al obtener inventario:", err);
            mostrarToast("error", "No se pudo actualizar el inventario");
        }
    };

    useEffect(() => {
        loadInitialData();
    }, []);

    useEffect(() => {
        fetchInventario();
    }, [selectedSucursal]);

    const mostrarToast = (icon, title) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: title,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
        });
    };

    const mostrarError = (mensaje) => {
        Swal.fire({
            title: "¡Error!",
            text: mensaje,
            icon: "error",
            confirmButtonText: "Aceptar",
        });
    };

    const articulosFiltrados = articulos.filter((art) => {
        if (articuloBuscar.trim() !== "") {
            const q = articuloBuscar.toLowerCase().trim();
            return art.nombre?.toLowerCase().includes(q);
        }
        return true;
    });

    // 1. Agregar Artículo (SweetAlert)
    const handleAgregarArticulo = async () => {
        let sucursalesSeleccionadas = isAdmin ? sucursales.map(s => s.idSucursal) : [userSucursal];

        const { value: formValues } = await MySwal.fire({
            title: "AGREGAR NUEVO ARTÍCULO",
            width: "65%",
            customClass: {
                title: "tituloDegradado",
                popup: "swalMaxHeight",
                confirmButton: "btnConfirmBlue",
            },
            html: `
                <div style="display:flex;flex-direction:column;gap:1vw;text-align:left;max-height:65vh;overflow-y:auto;padding-right:0.5vw;">
                    <div style="display:flex;gap:1vw;flex-wrap:wrap;">
                        <div style="display:flex;flex-direction:column;gap:0.25vw;flex:2;min-width:200px;">
                            <label for="swal-art-nombre" style="font-weight:700;font-size:0.95vw;">Nombre del Artículo / Consumible *:</label>
                            <input id="swal-art-nombre" class="input-swal" placeholder="" style="padding:0.6vw;" />
                        </div>
                        <div style="display:flex;flex-direction:column;gap:0.25vw;flex:1;min-width:140px;">
                            <label for="swal-art-minimo" style="font-weight:700;font-size:0.95vw;">Stock Mínimo Alerta *:</label>
                            <input id="swal-art-minimo" type="number" min="0" value="5" class="input-swal" style="padding:0.6vw;" />
                        </div>
                    </div>

                    <div class="tituloDegradado" style="font-size:0.9vw;padding:0.4vw;border-radius:6px;text-align:center;">
                        SUCURSALES DONDE SE REGISTRARÁ
                    </div>
                    <div style="display:flex;gap:1vw;flex-wrap:wrap;background:#f8fafc;padding:0.6vw;border-radius:6px;border:1px solid #e2e8f0;">
                        ${sucursales.length > 0 ? sucursales.map(s => `
                            <label style="display:flex;align-items:center;gap:0.4vw;font-size:0.9vw;cursor:pointer;">
                                <input type="checkbox" class="swal-sucursal-check" value="${s.idSucursal}" ${sucursalesSeleccionadas.includes(s.idSucursal) ? "checked" : ""} ${!isAdmin ? "disabled" : ""} />
                                <span>${s.nombre || s.nombreSucursal}</span>
                            </label>
                        `).join("") : '<span>Sucursal actual (' + userSucursal + ')</span>'}
                    </div>

                    <div class="tituloDegradado" style="font-size:0.9vw;padding:0.4vw;border-radius:6px;text-align:center;">
                        RELACIÓN DE CONSUMO POR ESTUDIO (CANTIDAD QUE CONSUME CADA PRUEBA)
                    </div>
                    <div style="display:flex;flex-direction:column;gap:0.5vw;">
                        <input id="swal-search-estudio" placeholder="Filtrar estudio..." style="padding:0.4vw;font-size:0.85vw;border-radius:4px;border:1px solid #ccc;" />
                        <div id="swal-estudios-container" style="max-height:22vh;overflow-y:auto;border:1px solid #e2e8f0;border-radius:6px;padding:0.5vw;background:#fff;">
                            ${estudios.map(e => `
                                <div class="estudio-item-row" data-name="${(e.nombre || '').toLowerCase()}" style="display:flex;align-items:center;justify-content:space-between;padding:0.3vw 0;border-bottom:1px solid #f1f5f9;">
                                    <span style="font-size:0.85vw;font-weight:600;max-width:65%;">${e.codigo ? e.codigo + ' - ' : ''}${e.nombre}</span>
                                    <div style="display:flex;align-items:center;gap:0.3vw;">
                                        <span style="font-size:0.8vw;color:#64748b;">Consumo:</span>
                                        <input type="number" step="1" min="0" class="input-swal swal-estudio-consumo" data-id="${e.idEstudio}" placeholder="0" style="width:4.5vw;padding:0.3vw;font-size:0.85vw;" />
                                    </div>
                                </div>
                            `).join("")}
                        </div>
                    </div>
                </div>
            `,
            didOpen: () => {
                const searchInput = document.getElementById("swal-search-estudio");
                const rows = document.querySelectorAll(".estudio-item-row");
                searchInput?.addEventListener("input", (e) => {
                    const q = e.target.value.toLowerCase().trim();
                    rows.forEach(r => {
                        const name = r.getAttribute("data-name") || "";
                        r.style.display = name.includes(q) ? "flex" : "none";
                    });
                });
            },
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Guardar Artículo",
            cancelButtonText: "Cancelar",
            preConfirm: () => {
                const nombre = document.getElementById("swal-art-nombre")?.value?.trim();
                const stockMinimo = parseFloat(document.getElementById("swal-art-minimo")?.value);

                if (!nombre) {
                    Swal.showValidationMessage("El nombre del artículo es obligatorio");
                    return false;
                }
                if (isNaN(stockMinimo) || stockMinimo < 0) {
                    Swal.showValidationMessage("El stock mínimo debe ser un número >= 0");
                    return false;
                }

                const checkedSucursales = Array.from(document.querySelectorAll(".swal-sucursal-check:checked")).map(el => parseInt(el.value));
                if (checkedSucursales.length === 0) {
                    Swal.showValidationMessage("Debe seleccionar al menos una sucursal");
                    return false;
                }

                const relacionesEstudios = [];
                document.querySelectorAll(".swal-estudio-consumo").forEach(inp => {
                    const val = parseFloat(inp.value);
                    const idEst = parseInt(inp.getAttribute("data-id"));
                    if (!isNaN(val) && val > 0 && idEst) {
                        relacionesEstudios.push({
                            idEstudio: idEst,
                            consumo: val
                        });
                    }
                });

                return {
                    nombre,
                    stockMinimo,
                    sucursales: checkedSucursales,
                    relacionesEstudios
                };
            }
        });

        if (formValues) {
            setProcessingAction(true);
            try {
                const res = await InventariosService.agregarArticulo(formValues);
                if (res?.estatus === "OK") {
                    mostrarToast("success", "Artículo creado correctamente");
                    await fetchInventario();
                } else {
                    mostrarError(res?.mensaje || "No se pudo agregar el artículo");
                }
            } catch (err) {
                console.error(err);
                mostrarError("Error al guardar el artículo");
            } finally {
                setProcessingAction(false);
            }
        }
    };

    // 2. Configurar / Actualizar Consumo de un Artículo por Estudio (actualizarConsumo)
    const handleActualizarConsumo = async (articuloSeleccionado = null) => {
        if (articulosFiltrados.length === 0) {
            mostrarError("No hay artículos disponibles para configurar.");
            return;
        }

        const targetInitialArt = articuloSeleccionado
            ? articulosFiltrados.find(a => String(a.idArticulo) === String(articuloSeleccionado.idArticulo))
            : null;
        const selectedArtId = targetInitialArt ? targetInitialArt.idArticulo : null;

        const getConsumoForEstudio = (artObj, idEst) => {
            if (!artObj) return "";
            if (artObj.relacionesEstudios && artObj.relacionesEstudios[idEst] !== undefined) {
                return artObj.relacionesEstudios[idEst];
            }
            if (artObj.relacionesEstudios && artObj.relacionesEstudios[String(idEst)] !== undefined) {
                return artObj.relacionesEstudios[String(idEst)];
            }
            if (Array.isArray(artObj.relaciones)) {
                const rel = artObj.relaciones.find(r => String(r.idEstudio) === String(idEst));
                if (rel) return rel.consumo;
            }
            return "";
        };

        const { value: formValues } = await MySwal.fire({
            title: "CONFIGURAR CONSUMO DE ARTÍCULO POR ESTUDIO",
            width: "60%",
            customClass: {
                title: "tituloDegradado",
                popup: "swalMaxHeight",
                confirmButton: "btnConfirmBlue",
            },
            html: `
                <div style="display:flex;flex-direction:column;gap:1vw;text-align:left;max-height:60vh;overflow-y:auto;padding-right:0.5vw;">
                    <div style="display:flex;flex-direction:column;gap:0.2vw;position:relative;">
                        <label style="font-weight:700;font-size:0.9vw;">Seleccionar Artículo *:</label>
                        <input id="swal-upd-articulo-input" type="text" class="input-swal" placeholder="Escriba para buscar artículo..." autocomplete="off" style="padding:0.6vw;" />
                        <input id="swal-upd-articulo-id" type="hidden" value="" />
                        <div id="swal-upd-articulo-dropdown" style="display:none;position:absolute;top:100%;left:0;right:0;max-height:180px;overflow-y:auto;background:#fff;border:1px solid #cbd5e1;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,0.15);z-index:9999;margin-top:2px;">
                        </div>
                    </div>

                    <div class="tituloDegradado" style="font-size:0.9vw;padding:0.4vw;border-radius:6px;text-align:center;">
                        MODIFICAR CANTIDAD DE CONSUMO POR ESTUDIO
                    </div>
                    
                    <input id="swal-upd-search-estudio" placeholder="Filtrar estudio..." style="padding:0.4vw;font-size:0.85vw;border-radius:4px;border:1px solid #ccc;" />

                    <div id="swal-upd-estudios-list" style="max-height:30vh;overflow-y:auto;border:1px solid #e2e8f0;border-radius:6px;padding:0.5vw;background:#fff;">
                        ${estudios.map(e => {
                const initVal = getConsumoForEstudio(targetInitialArt, e.idEstudio);
                return `
                                <div class="estudio-upd-row" data-name="${(e.nombre || '').toLowerCase()}" style="display:flex;align-items:center;justify-content:space-between;padding:0.35vw 0;border-bottom:1px solid #f1f5f9;">
                                    <span style="font-size:0.85vw;font-weight:600;max-width:65%;">${e.codigo ? e.codigo + ' - ' : ''}${e.nombre}</span>
                                    <div style="display:flex;align-items:center;gap:0.3vw;">
                                        <span style="font-size:0.8vw;color:#64748b;">Consumo por estudio:</span>
                                        <input type="number" step="1" min="0" class="input-swal swal-upd-consumo-input" data-id="${e.idEstudio}" value="${initVal !== null && initVal !== undefined ? initVal : ''}" placeholder="0" style="width:4.5vw;padding:0.3vw;font-size:0.85vw;" />
                                    </div>
                                </div>
                            `;
            }).join("")}
                    </div>
                </div>
            `,
            didOpen: () => {
                const searchInput = document.getElementById("swal-upd-search-estudio");
                const rows = document.querySelectorAll(".estudio-upd-row");

                const updateInputsForArticle = (artId) => {
                    const targetArt = articulosFiltrados.find(a => String(a.idArticulo) === String(artId));
                    document.querySelectorAll(".swal-upd-consumo-input").forEach(inp => {
                        const estId = inp.getAttribute("data-id");
                        const val = getConsumoForEstudio(targetArt, estId);
                        inp.value = (val !== null && val !== undefined && val !== "") ? val : "";
                    });
                };

                setupSwalAutocomplete({
                    inputId: "swal-upd-articulo-input",
                    hiddenId: "swal-upd-articulo-id",
                    dropdownId: "swal-upd-articulo-dropdown",
                    items: articulosFiltrados,
                    initialSelectedId: selectedArtId,
                    onSelect: (artId) => updateInputsForArticle(artId)
                });

                searchInput?.addEventListener("input", (ev) => {
                    const q = ev.target.value.toLowerCase().trim();
                    rows.forEach(r => {
                        const name = r.getAttribute("data-name") || "";
                        r.style.display = name.includes(q) ? "flex" : "none";
                    });
                });
            },
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Guardar Cambios de Consumo",
            cancelButtonText: "Cancelar",
            preConfirm: () => {
                const idArticulo = parseInt(document.getElementById("swal-upd-articulo-id")?.value);
                const artValido = articulosFiltrados.find(a => String(a.idArticulo) === String(idArticulo));
                if (!idArticulo || !artValido) {
                    Swal.showValidationMessage("Debe seleccionar un artículo válido de la lista");
                    return false;
                }

                const cambios = [];
                document.querySelectorAll(".swal-upd-consumo-input").forEach(inp => {
                    const val = parseFloat(inp.value);
                    const idEst = parseInt(inp.getAttribute("data-id"));
                    if (!isNaN(val) && val >= 0 && idEst) {
                        cambios.push({
                            idArticuloN: idArticulo,
                            idEstudioN: idEst,
                            consumoN: val
                        });
                    }
                });

                if (cambios.length === 0) {
                    Swal.showValidationMessage("Debe ingresar al menos un valor de consumo a actualizar.");
                    return false;
                }

                return { idArticulo, cambios };
            }
        });

        if (formValues) {
            setProcessingAction(true);
            try {
                let successCount = 0;
                for (const c of formValues.cambios) {
                    const res = await InventariosService.actualizarConsumo(c);
                    if (res?.estatus === "OK") {
                        successCount++;
                    }
                }
                mostrarToast("success", `Consumo por estudio actualizado (${successCount} estudio(s))`);
                await fetchInventario();
            } catch (err) {
                console.error(err);
                mostrarError("Error al actualizar el consumo por estudio");
            } finally {
                setProcessingAction(false);
            }
        }
    };

    // 3. Registrar Entrada
    const handleRegistrarEntrada = async () => {
        if (articulosFiltrados.length === 0) {
            mostrarError("No hay artículos disponibles en el inventario de esta sucursal");
            return;
        }

        const { value: formValues } = await MySwal.fire({
            title: "REGISTRAR ENTRADA DE INVENTARIO",
            width: "50%",
            customClass: {
                title: "tituloDegradado",
                popup: "swalMaxHeight",
                confirmButton: "btnConfirmBlue",
            },
            html: `
                <div style="display:flex;flex-direction:column;gap:0.8vw;text-align:left;">
                    ${isAdmin ? `
                        <div style="display:flex;flex-direction:column;gap:0.2vw;">
                            <label style="font-weight:700;font-size:0.9vw;">Sucursal Destino *:</label>
                            <select id="swal-ent-sucursal" class="input-swal" style="padding:0.6vw;">
                                ${sucursales.map(s => `
                                    <option value="${s.idSucursal}" ${String(s.idSucursal) === String(selectedSucursal !== 'todas' ? selectedSucursal : userSucursal) ? 'selected' : ''}>
                                        ${s.nombre || s.nombreSucursal}
                                    </option>
                                `).join("")}
                            </select>
                        </div>
                    ` : ""}
                    <div style="display:flex;flex-direction:column;gap:0.2vw;position:relative;">
                        <label style="font-weight:700;font-size:0.9vw;">Artículo *:</label>
                        <input id="swal-ent-articulo-input" type="text" class="input-swal" placeholder="Escriba para buscar artículo..." autocomplete="off" style="padding:0.6vw;" />
                        <input id="swal-ent-articulo-id" type="hidden" value="" />
                        <div id="swal-ent-articulo-dropdown" style="display:none;position:absolute;top:100%;left:0;right:0;max-height:180px;overflow-y:auto;background:#fff;border:1px solid #cbd5e1;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,0.15);z-index:9999;margin-top:2px;">
                        </div>
                    </div>
                    <div style="display:flex;flex-direction:column;gap:0.2vw;">
                        <label style="font-weight:700;font-size:0.9vw;">Cantidad a Ingresar *:</label>
                        <input id="swal-ent-cantidad" type="number" min="1" step="1" class="input-swal" placeholder="Ej. 50" style="padding:0.6vw;" />
                    </div>
                    <div style="display:flex;flex-direction:column;gap:0.2vw;">
                        <label style="font-weight:700;font-size:0.9vw;">Motivo (Opcional):</label>
                        <input id="swal-ent-motivo" class="input-swal" placeholder="Ej. Reabastecimiento de proveedor" style="padding:0.6vw;" />
                    </div>
                </div>
            `,
            didOpen: () => {
                setupSwalAutocomplete({
                    inputId: "swal-ent-articulo-input",
                    hiddenId: "swal-ent-articulo-id",
                    dropdownId: "swal-ent-articulo-dropdown",
                    items: articulosFiltrados,
                    initialSelectedId: null
                });
            },
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Registrar Entrada",
            cancelButtonText: "Cancelar",
            preConfirm: () => {
                const idArticulo = parseInt(document.getElementById("swal-ent-articulo-id")?.value);
                const cantidad = parseFloat(document.getElementById("swal-ent-cantidad")?.value);
                const motivo = document.getElementById("swal-ent-motivo")?.value?.trim();
                const idSucursal = isAdmin
                    ? parseInt(document.getElementById("swal-ent-sucursal")?.value)
                    : userSucursal;

                const artValido = articulosFiltrados.find(a => String(a.idArticulo) === String(idArticulo));
                if (!idArticulo || !artValido) {
                    Swal.showValidationMessage("Debe seleccionar un artículo válido de la lista");
                    return false;
                }
                if (isNaN(cantidad) || cantidad <= 0) {
                    Swal.showValidationMessage("La cantidad debe ser mayor a 0");
                    return false;
                }

                return {
                    idArticulo,
                    cantidad,
                    motivo,
                    idSucursal,
                    idUsuario: currentU?.id || 1,
                    nombreUsuario: currentU?.nombre || "Usuario"
                };
            }
        });

        if (formValues) {
            setProcessingAction(true);
            try {
                const res = await InventariosService.registrarEntrada(formValues);
                if (res?.estatus === "OK") {
                    mostrarToast("success", "Entrada registrada correctamente");
                    await fetchInventario();
                } else {
                    mostrarError(res?.mensaje || "No se pudo registrar la entrada");
                }
            } catch (err) {
                console.error(err);
                mostrarError("Error al registrar entrada de inventario");
            } finally {
                setProcessingAction(false);
            }
        }
    };

    // 4. Registrar Salida Extra (Solo Admin)
    const handleRegistrarSalida = async () => {
        if (!isAdmin) {
            mostrarError("Esta acción solo está permitida para usuarios administradores.");
            return;
        }

        if (articulosFiltrados.length === 0) {
            mostrarError("No hay artículos disponibles en el inventario.");
            return;
        }

        const { value: formValues } = await MySwal.fire({
            title: "REGISTRAR SALIDA EXTRA (SOLO ADMIN)",
            width: "50%",
            customClass: {
                title: "tituloDegradado",
                popup: "swalMaxHeight",
                confirmButton: "btnConfirmBlue",
            },
            html: `
                <div style="display:flex;flex-direction:column;gap:0.8vw;text-align:left;">
                    <div style="display:flex;flex-direction:column;gap:0.2vw;">
                        <label style="font-weight:700;font-size:0.9vw;">Sucursal Origen *:</label>
                        <select id="swal-sal-sucursal" class="input-swal" style="padding:0.6vw;">
                            ${sucursales.map(s => `
                                <option value="${s.idSucursal}" ${String(s.idSucursal) === String(selectedSucursal !== 'todas' ? selectedSucursal : userSucursal) ? 'selected' : ''}>
                                    ${s.nombre || s.nombreSucursal}
                                </option>
                            `).join("")}
                        </select>
                    </div>
                    <div style="display:flex;flex-direction:column;gap:0.2vw;position:relative;">
                        <label style="font-weight:700;font-size:0.9vw;">Artículo *:</label>
                        <input id="swal-sal-articulo-input" type="text" class="input-swal" placeholder="Escriba para buscar artículo..." autocomplete="off" style="padding:0.6vw;" />
                        <input id="swal-sal-articulo-id" type="hidden" value="" />
                        <input id="swal-sal-articulo-stock" type="hidden" value="0" />
                        <div id="swal-sal-articulo-dropdown" style="display:none;position:absolute;top:100%;left:0;right:0;max-height:180px;overflow-y:auto;background:#fff;border:1px solid #cbd5e1;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,0.15);z-index:9999;margin-top:2px;">
                        </div>
                    </div>
                    <div style="display:flex;flex-direction:column;gap:0.2vw;">
                        <label style="font-weight:700;font-size:0.9vw;">Cantidad a Retirar *:</label>
                        <input id="swal-sal-cantidad" type="number" min="1" step="1" class="input-swal" placeholder="Ej. 5" style="padding:0.6vw;" />
                    </div>
                    <div style="display:flex;flex-direction:column;gap:0.2vw;">
                        <label style="font-weight:700;font-size:0.9vw;color:#c53030;">Motivo de Salida (OBLIGATORIO) *:</label>
                        <input id="swal-sal-motivo" class="input-swal" placeholder="Ej. Material caducado / muestra rota / merma" style="padding:0.6vw;border:1px solid #feb2b2;" />
                    </div>
                </div>
            `,
            didOpen: () => {
                setupSwalAutocomplete({
                    inputId: "swal-sal-articulo-input",
                    hiddenId: "swal-sal-articulo-id",
                    extraHiddenId: "swal-sal-articulo-stock",
                    dropdownId: "swal-sal-articulo-dropdown",
                    items: articulosFiltrados,
                    initialSelectedId: null
                });
            },
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Registrar Salida",
            cancelButtonText: "Cancelar",
            preConfirm: () => {
                const idArticulo = parseInt(document.getElementById("swal-sal-articulo-id")?.value);
                const cantidad = parseFloat(document.getElementById("swal-sal-cantidad")?.value);
                const motivo = document.getElementById("swal-sal-motivo")?.value?.trim();
                const idSucursal = parseInt(document.getElementById("swal-sal-sucursal")?.value);

                const currentStock = parseFloat(document.getElementById("swal-sal-articulo-stock")?.value || "0");
                const artValido = articulosFiltrados.find(a => String(a.idArticulo) === String(idArticulo));

                if (!idArticulo || !artValido) {
                    Swal.showValidationMessage("Debe seleccionar un artículo válido de la lista");
                    return false;
                }
                if (isNaN(cantidad) || cantidad <= 0) {
                    Swal.showValidationMessage("La cantidad debe ser mayor a 0");
                    return false;
                }
                if (cantidad > currentStock) {
                    Swal.showValidationMessage(`La cantidad (${cantidad}) supera el stock disponible (${currentStock})`);
                    return false;
                }
                if (!motivo) {
                    Swal.showValidationMessage("El motivo de salida extra es OBLIGATORIO");
                    return false;
                }

                return {
                    idArticulo,
                    cantidad,
                    motivo,
                    idSucursal,
                    idUsuario: currentU?.id || 1,
                    nombreUsuario: currentU?.nombre || "Administrador"
                };
            }
        });

        if (formValues) {
            setProcessingAction(true);
            try {
                const res = await InventariosService.registrarSalida(formValues);
                if (res?.estatus === "OK") {
                    mostrarToast("success", "Salida extra registrada correctamente");
                    await fetchInventario();
                } else {
                    mostrarError(res?.mensaje || "No se pudo registrar la salida extra");
                }
            } catch (err) {
                console.error(err);
                mostrarError("Error al registrar la salida de inventario");
            } finally {
                setProcessingAction(false);
            }
        }
    };

    // 5. Ver Historial de Movimientos
    const handleVerHistorial = async () => {
        try {
            const res = await InventariosService.getHistorialMovimientos(selectedSucursal);
            const movimientos = res?.movimientos || [];

            MySwal.fire({
                title: "HISTORIAL DE MOVIMIENTOS DE INVENTARIO",
                width: "75%",
                customClass: {
                    title: "tituloDegradado",
                    popup: "swalMaxHeight",
                    confirmButton: "btnConfirmBlue",
                },
                html: `
                    <div style="max-height:60vh;overflow-y:auto;text-align:left;">
                        <table style="width:100%;border-collapse:collapse;font-size:0.85vw;">
                            <thead>
                                <tr style="background-color:#18234f;color:white;">
                                    <th style="padding:8px;text-align:left;">Fecha / Hora</th>
                                    <th style="padding:8px;text-align:left;">Usuario</th>
                                    <th style="padding:8px;text-align:left;">Artículo</th>
                                    <th style="padding:8px;text-align:center;">Tipo</th>
                                    <th style="padding:8px;text-align:right;">Cantidad</th>
                                    <th style="padding:8px;text-align:left;">Motivo</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${movimientos.length > 0 ? movimientos.map((m, idx) => `
                                    <tr style="border-bottom:1px solid #e2e8f0;background-color:${idx % 2 === 0 ? '#fff' : '#f8fafc'};">
                                        <td style="padding:8px;">${m.fechaHora}</td>
                                        <td style="padding:8px;font-weight:600;">${m.usuario}</td>
                                        <td style="padding:8px;">${m.articulo}</td>
                                        <td style="padding:8px;text-align:center;">
                                            <span style="padding:2px 8px;border-radius:12px;font-size:0.75vw;font-weight:bold;color:white;background-color:${m.tipo === 'Entrada' ? '#2e7d32' : '#d32f2f'};">
                                                ${m.tipo}
                                            </span>
                                        </td>
                                        <td style="padding:8px;text-align:right;font-weight:bold;">${m.cantidad}</td>
                                        <td style="padding:8px;color:#475569;">${m.motivo || '-'}</td>
                                    </tr>
                                `).join("") : `
                                    <tr>
                                        <td colspan="6" style="padding:20px;text-align:center;color:#64748b;">No hay movimientos registrados</td>
                                    </tr>
                                `}
                            </tbody>
                        </table>
                    </div>
                `,
                confirmButtonText: "Cerrar",
            });
        } catch (err) {
            console.error(err);
            mostrarError("No se pudo obtener el historial de movimientos");
        }
    };

    // 6. Ver detalle de Entradas y Salidas de un Artículo específico
    const handleVerDetalleArticulo = async (art) => {
        try {
            const res = await InventariosService.getHistorialMovimientos(selectedSucursal);
            const movsArticulo = (res?.movimientos || []).filter(m => String(m.idArticulo) === String(art.idArticulo));

            const sumEntradas = movsArticulo
                .filter(m => String(m.tipo).toLowerCase().includes("entrada"))
                .reduce((sum, curr) => sum + (parseFloat(curr.cantidad) || 0), 0);

            const sumSalidas = movsArticulo
                .filter(m => !String(m.tipo).toLowerCase().includes("entrada"))
                .reduce((sum, curr) => sum + (parseFloat(curr.cantidad) || 0), 0);

            const entradasMostrar = (art.entradasTotales !== null && art.entradasTotales !== undefined)
                ? art.entradasTotales
                : sumEntradas;

            const salidasMostrar = (art.salidasTotales !== null && art.salidasTotales !== undefined)
                ? art.salidasTotales
                : sumSalidas;

            const stockMostrar = (art.stock !== null && art.stock !== undefined) ? art.stock : 0;

            MySwal.fire({
                title: `DETALLE DE MOVIMIENTOS: ${art.nombre.toUpperCase()}`,
                width: "70%",
                customClass: {
                    title: "tituloDegradado",
                    popup: "swalMaxHeight",
                    confirmButton: "btnConfirmBlue",
                },
                html: `
                    <div style="display:flex;gap:1vw;justify-content:space-around;margin-bottom:1vw;background:#f1f5f9;padding:0.8vw;border-radius:8px;">
                        <div><strong>Stock Actual:</strong> <span style="color:#006787;font-size:1.1vw;font-weight:bold;">${stockMostrar}</span></div>
                        <div><strong>Entradas Totales:</strong> <span style="color:#2e7d32;font-size:1.1vw;font-weight:bold;">${entradasMostrar}</span></div>
                        <div><strong>Salidas Totales:</strong> <span style="color:#d32f2f;font-size:1.1vw;font-weight:bold;">${salidasMostrar}</span></div>
                    </div>
                    <div style="max-height:50vh;overflow-y:auto;text-align:left;">
                        <table style="width:100%;border-collapse:collapse;font-size:0.85vw;">
                            <thead>
                                <tr style="background-color:#18234f;color:white;">
                                    <th style="padding:8px;text-align:left;">Fecha / Hora</th>
                                    <th style="padding:8px;text-align:left;">Usuario</th>
                                    <th style="padding:8px;text-align:center;">Tipo</th>
                                    <th style="padding:8px;text-align:right;">Cantidad</th>
                                    <th style="padding:8px;text-align:left;">Motivo</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${movsArticulo.length > 0 ? movsArticulo.map((m, idx) => `
                                    <tr style="border-bottom:1px solid #e2e8f0;background-color:${idx % 2 === 0 ? '#fff' : '#f8fafc'};">
                                        <td style="padding:8px;">${m.fechaHora}</td>
                                        <td style="padding:8px;font-weight:600;">${m.usuario}</td>
                                        <td style="padding:8px;text-align:center;">
                                            <span style="padding:2px 8px;border-radius:12px;font-size:0.75vw;font-weight:bold;color:white;background-color:${m.tipo === 'Entrada' ? '#2e7d32' : '#d32f2f'};">
                                                ${m.tipo}
                                            </span>
                                        </td>
                                        <td style="padding:8px;text-align:right;font-weight:bold;">${m.cantidad}</td>
                                        <td style="padding:8px;color:#475569;">${m.motivo || '-'}</td>
                                    </tr>
                                `).join("") : `
                                    <tr>
                                        <td colspan="5" style="padding:15px;text-align:center;color:#64748b;">Sin movimientos registrados para este artículo</td>
                                    </tr>
                                `}
                            </tbody>
                        </table>
                    </div>
                `,
                confirmButtonText: "Cerrar",
            });
        } catch (err) {
            console.error(err);
            mostrarError("No se pudieron consultar los detalles del artículo");
        }
    };

    // 7. Eliminar Artículo (Solo Admin)
    const handleDeleteArticulo = async (art) => {
        if (!isAdmin) {
            mostrarError("Solo el administrador puede eliminar artículos del inventario");
            return;
        }

        Swal.fire({
            title: "¿Eliminar artículo?",
            text: `¿Desea eliminar el artículo "${art.nombre}" del inventario? ¡Se eliminaran sus entradas y salidas!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#d32f2f"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setProcessingAction(true);
                try {
                    const res = await InventariosService.deleteArticulo(art.idArticulo);
                    if (res?.estatus === "OK") {
                        mostrarToast("success", "Artículo eliminado");
                        await fetchInventario();
                    } else {
                        mostrarError(res?.mensaje || "No se pudo eliminar el artículo");
                    }
                } catch (err) {
                    console.error(err);
                    mostrarError("Error al eliminar el artículo");
                } finally {
                    setProcessingAction(false);
                }
            }
        });
    };

    // 8. Exportar Inventario a Excel
    const handleExportarExcel = () => {
        const fechaActual = new Date().toLocaleDateString("es-MX", {
            day: "2-digit",
            month: "long",
            year: "numeric"
        });

        let tableHtml = `<table border="1">`;
        tableHtml += `<tr><td colspan="${5 + estudios.length}" style="font-weight: bold; font-size: 14pt; height: 30px; text-align: center; background-color: #006787; color: white;">Reporte de Inventario de Consumibles (${fechaActual})</td></tr>`;

        tableHtml += `<tr style="background-color: #18234f; color: white; font-weight: bold; text-align: center;">`;
        tableHtml += `<td>Artículo</td>`;
        tableHtml += `<td>Stock Actual</td>`;
        tableHtml += `<td>Entradas Totales</td>`;
        tableHtml += `<td>Salidas Totales</td>`;
        tableHtml += `<td>Stock Mínimo Alerta</td>`;
        estudios.forEach((e) => {
            tableHtml += `<td>Gastado en ${e.codigo ? e.codigo + ' - ' : ''}${e.nombre}</td>`;
        });
        tableHtml += `</tr>`;

        articulosFiltrados.forEach((art) => {
            tableHtml += `<tr>`;
            tableHtml += `<td style="font-weight: bold;">${art.nombre || ""}</td>`;
            tableHtml += `<td style="text-align: right;">${art.stock}</td>`;
            tableHtml += `<td style="text-align: right;">${art.entradasTotales}</td>`;
            tableHtml += `<td style="text-align: right;">${art.salidasTotales}</td>`;
            tableHtml += `<td style="text-align: right;">${art.stockMinimo || stockMinimoUmbral}</td>`;

            estudios.forEach((e) => {
                const gastado = art.estudiosGastado
                    ? (art.estudiosGastado[e.idEstudio] ?? art.estudiosGastado[String(e.idEstudio)] ?? 0)
                    : 0;
                tableHtml += `<td style="text-align: right;">${gastado}</td>`;
            });
            tableHtml += `</tr>`;
        });

        tableHtml += `</table>`;

        const excelFile = `
          <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
          <head>
          <meta charset="utf-8" />
          <style> br { mso-data-placement:same-cell; } </style>
          </head>
          <body>${tableHtml}</body>
          </html>
        `;

        const blob = new Blob([excelFile], { type: "application/vnd.ms-excel" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Inventario_Consumibles_${new Date().toISOString().slice(0, 10)}.xls`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        mostrarToast("success", "Inventario exportado a Excel");
    };


    return (
        <Layout>
            <Content>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        height: "50%",
                        width: "100vw",
                        paddingTop: "2vh",
                        paddingBottom: "2vh",
                    }}
                >
                    <Stack spacing={2} sx={{ width: "95vw" }}>
                        <Paper
                            elevation={3}
                            sx={{ p: 2, borderRadius: 4 }}
                            className="paperListaP"
                        >
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                                <Typography
                                    variant="h7"
                                    fontWeight="bold"
                                    sx={{
                                        background: "linear-gradient(90deg, #006787, #014e65)",
                                        color: "white",
                                        padding: "0.5vw 1vw",
                                        borderRadius: "8px",
                                        display: "inline-block",
                                        fontWeight: "bold",
                                        fontSize: "1.1vw"
                                    }}
                                >
                                    INVENTARIO DE CONSUMIBLES
                                </Typography>

                                {isAdmin && (
                                    <Chip
                                        icon={<StorefrontIcon sx={{ color: "white !important" }} />}
                                        label="Modo Administrador (Todas las sucursales)"
                                        sx={{ backgroundColor: "#18234f", color: "white", fontWeight: "bold" }}
                                    />
                                )}
                            </Box>

                            {/* Contenedor principal */}
                            <Grid container spacing={"0.3vw"}>
                                <Grid
                                    item
                                    xs={12}
                                    container
                                    spacing={"1vw"}
                                    sx={{ paddingTop: "0.4vw" }}
                                >
                                    <Stack direction="row" spacing={"0.8vw"} alignItems="flex-start">
                                        {/* PANEL LATERAL DE BOTONES Y FILTROS */}
                                        <Box
                                            sx={{
                                                borderRadius: 4,
                                                overflow: "hidden",
                                                width: "15vw",
                                                backgroundColor: "#f6f8fb",
                                                display: "flex",
                                                flexDirection: "column",
                                                border: "1px solid #e2e8f0",
                                                p: 1.5,
                                                gap: 1.5
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: "bold", fontSize: "1vw", color: "#18234f", borderBottom: "2px solid #006787", pb: 0.5 }}>
                                                Panel de Control
                                            </Typography>

                                            {/* Selector de Sucursal */}
                                            <Box>
                                                <Typography sx={{ fontWeight: "bold", fontSize: "0.85vw", mb: 0.5 }}>
                                                    Sucursal:
                                                </Typography>
                                                <Select
                                                    fullWidth
                                                    value={selectedSucursal}
                                                    disabled={!isAdmin || processingAction}
                                                    onChange={(e) => setSelectedSucursal(e.target.value)}
                                                    sx={{
                                                        height: "4.5vh",
                                                        fontSize: "0.9vw",
                                                        backgroundColor: "white"
                                                    }}
                                                >
                                                    {isAdmin && <MenuItem value="todas">--SELECCIONE--</MenuItem>}
                                                    {sucursales.map((s) => (
                                                        <MenuItem key={s.idSucursal} value={s.idSucursal} sx={{ fontSize: "0.9vw" }}>
                                                            {s.nombre || s.nombreSucursal}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Box>

                                            {/* Buscador de artículos */}
                                            <Box>
                                                <Typography sx={{ fontWeight: "bold", fontSize: "0.85vw", mb: 0.5 }}>
                                                    Buscar Artículo:
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    value={articuloBuscar}
                                                    onChange={(e) => setArticuloBuscar(e.target.value)}
                                                    placeholder="Nombre del consumible..."
                                                    sx={{
                                                        "& .MuiInputBase-root": { height: "4.5vh", backgroundColor: "white" },
                                                        "& .MuiInputBase-input": { fontSize: "0.9vw", padding: "0.4vw" },
                                                    }}
                                                />
                                            </Box>

                                            {/* BOTONES PRINCIPALES */}
                                            <Stack spacing={1} sx={{ mt: 1 }}>
                                                <Button
                                                    variant="contained"
                                                    disabled={processingAction}
                                                    onClick={handleAgregarArticulo}
                                                    startIcon={<PlaylistAddRoundedIcon />}
                                                    sx={{
                                                        backgroundColor: "#006787",
                                                        "&:hover": { backgroundColor: "#014e65" },
                                                        fontWeight: "bold",
                                                        fontSize: "0.85vw",
                                                        textTransform: "none"
                                                    }}
                                                >
                                                    Agregar Artículo
                                                </Button>

                                                <Button
                                                    variant="contained"
                                                    disabled={processingAction}
                                                    onClick={() => handleActualizarConsumo(null)}
                                                    startIcon={<SettingsIcon />}
                                                    sx={{
                                                        backgroundColor: "#4f46e5",
                                                        "&:hover": { backgroundColor: "#4338ca" },
                                                        fontWeight: "bold",
                                                        fontSize: "0.85vw",
                                                        textTransform: "none"
                                                    }}
                                                >
                                                    Configurar Consumo
                                                </Button>

                                                <Button
                                                    variant="contained"
                                                    disabled={processingAction}
                                                    onClick={handleRegistrarEntrada}
                                                    startIcon={<AddCircleIcon />}
                                                    sx={{
                                                        backgroundColor: "#2e7d32",
                                                        "&:hover": { backgroundColor: "#1b5e20" },
                                                        fontWeight: "bold",
                                                        fontSize: "0.85vw",
                                                        textTransform: "none"
                                                    }}
                                                >
                                                    Registrar Entrada
                                                </Button>

                                                {isAdmin && (
                                                    <Button
                                                        variant="contained"
                                                        disabled={processingAction}
                                                        onClick={handleRegistrarSalida}
                                                        startIcon={<RemoveCircleIcon />}
                                                        sx={{
                                                            backgroundColor: "#d32f2f",
                                                            "&:hover": { backgroundColor: "#9a0007" },
                                                            fontWeight: "bold",
                                                            fontSize: "0.85vw",
                                                            textTransform: "none"
                                                        }}
                                                    >
                                                        Registrar Salida Extra (Admin)
                                                    </Button>
                                                )}

                                                <Button
                                                    variant="outlined"
                                                    disabled={processingAction}
                                                    onClick={handleVerHistorial}
                                                    startIcon={<HistoryIcon />}
                                                    sx={{
                                                        borderColor: "#18234f",
                                                        color: "#18234f",
                                                        fontWeight: "bold",
                                                        fontSize: "0.85vw",
                                                        textTransform: "none"
                                                    }}
                                                >
                                                    Historial Movimientos
                                                </Button>

                                                <Button
                                                    variant="outlined"
                                                    disabled={processingAction}
                                                    onClick={handleExportarExcel}
                                                    startIcon={<Icon path={mdiFileExcel} size={0.9} color="#107c41" />}
                                                    sx={{
                                                        borderColor: "#107c41",
                                                        color: "#107c41",
                                                        fontWeight: "bold",
                                                        fontSize: "0.85vw",
                                                        textTransform: "none"
                                                    }}
                                                >
                                                    Exportar Excel (.xls)
                                                </Button>
                                            </Stack>
                                        </Box>

                                        {/* TABLA PRINCIPAL DE INVENTARIO */}
                                        <Box
                                            sx={{
                                                borderRadius: 4,
                                                overflowX: "auto",
                                                overflowY: "auto",
                                                width: "65vw",
                                                maxHeight: "75vh",
                                                backgroundColor: "#f6f8fb",
                                                display: "block",
                                                border: "1px solid #e2e8f0"
                                            }}
                                        >
                                            <Table sx={{ backgroundColor: "white", minWidth: "max-content", width: "max-content", "& .MuiTableCell-root": { padding: "6px 12px" } }}>
                                                <TableHead
                                                    stickyHeader
                                                    sx={{
                                                        backgroundColor: "#18234f",
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 2,
                                                    }}
                                                >
                                                    <TableRow>
                                                        <TableCell sx={{ color: "white", fontWeight: "bold", backgroundColor: "#18234f", minWidth: "14vw" }}>
                                                            Artículo
                                                        </TableCell>
                                                        <TableCell sx={{ color: "white", fontWeight: "bold", backgroundColor: "#18234f", textAlign: "center" }}>
                                                            Stock
                                                        </TableCell>
                                                        <TableCell sx={{ color: "white", fontWeight: "bold", backgroundColor: "#18234f", textAlign: "center" }}>
                                                            Entradas Totales
                                                        </TableCell>
                                                        <TableCell sx={{ color: "white", fontWeight: "bold", backgroundColor: "#18234f", textAlign: "center" }}>
                                                            Salidas Totales
                                                        </TableCell>
                                                        <TableCell sx={{ color: "white", fontWeight: "bold", backgroundColor: "#18234f", textAlign: "center" }}>
                                                            Acciones
                                                        </TableCell>
                                                        {/* Columnas Dinámicas por Estudio (Cantidad consumida/gastada en cada estudio) */}
                                                        {estudios.map((est) => (
                                                            <TableCell
                                                                key={est.idEstudio}
                                                                sx={{ color: "white", fontWeight: "bold", backgroundColor: "#18234f", textAlign: "center", minWidth: "8vw" }}
                                                            >
                                                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                                    <Typography sx={{ color: "#7dd3fc", fontWeight: "bold", fontSize: "0.75vw" }}>
                                                                        {est.codigo || "EST"}
                                                                    </Typography>
                                                                    <Typography sx={{ color: "white", fontSize: "0.85vw" }}>
                                                                        "{est.nombre}"
                                                                    </Typography>
                                                                    <Typography sx={{ color: "#cbd5e1", fontSize: "0.7vw", fontStyle: "italic" }}>
                                                                        (Gastado)
                                                                    </Typography>
                                                                </Box>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {loading ? (
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={5 + estudios.length}
                                                                align="center"
                                                                sx={{ py: 6 }}
                                                            >
                                                                <CircularProgress sx={{ color: "#006787" }} />
                                                                <Typography sx={{ mt: 2, fontSize: "1vw", color: "#006787", fontWeight: "bold" }}>
                                                                    Cargando inventario de consumibles...
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : articulosFiltrados.length > 0 ? (
                                                        articulosFiltrados.map((art) => {
                                                            const minStock = art.stockMinimo !== undefined ? art.stockMinimo : stockMinimoUmbral;
                                                            const isLowStock = art.stock <= minStock;

                                                            return (
                                                                <TableRow key={art.idArticulo} hover sx={{ backgroundColor: isLowStock ? "#fef2f2" : "white" }}>
                                                                    <TableCell sx={{ fontWeight: "600", color: "#0f172a" }}>
                                                                        {art.nombre}
                                                                        {isLowStock && (
                                                                            <Chip
                                                                                label="¡Stock Bajo!"
                                                                                size="small"
                                                                                sx={{ ml: 1, height: "18px", fontSize: "0.65vw", backgroundColor: "#ef4444", color: "white", fontWeight: "bold" }}
                                                                            />
                                                                        )}
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        <Typography
                                                                            sx={{
                                                                                fontWeight: "bold",
                                                                                fontSize: "1vw",
                                                                                color: isLowStock ? "#dc2626" : "#166534",
                                                                                backgroundColor: isLowStock ? "#fee2e2" : "#dcfce7",
                                                                                py: 0.3,
                                                                                px: 1,
                                                                                borderRadius: 2,
                                                                                display: "inline-block"
                                                                            }}
                                                                        >
                                                                            {art.stock}
                                                                        </Typography>
                                                                    </TableCell>

                                                                    <TableCell align="center" sx={{ fontWeight: "600", color: "#15803d" }}>
                                                                        {art.entradasTotales || 0}
                                                                    </TableCell>

                                                                    <TableCell align="center" sx={{ fontWeight: "600", color: "#b91c1c" }}>
                                                                        {art.salidasTotales || 0}
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        <Stack direction="row" spacing={0.5} justifyContent="center">
                                                                            <Tooltip title="Ver detalles de entradas / salidas">
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => handleVerDetalleArticulo(art)}
                                                                                    sx={{ color: "#006787" }}
                                                                                >
                                                                                    <VisibilityIcon sx={{ fontSize: "1.2vw" }} />
                                                                                </IconButton>
                                                                            </Tooltip>

                                                                            <Tooltip title="Configurar consumo por estudio">
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => handleActualizarConsumo(art)}
                                                                                    sx={{ color: "#4f46e5" }}
                                                                                >
                                                                                    <SettingsIcon sx={{ fontSize: "1.2vw" }} />
                                                                                </IconButton>
                                                                            </Tooltip>

                                                                            {isAdmin && (
                                                                                <Tooltip title="Eliminar artículo (Solo Admin)">
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={() => handleDeleteArticulo(art)}
                                                                                        sx={{ color: "#d32f2f" }}
                                                                                    >
                                                                                        <DeleteIcon sx={{ fontSize: "1.2vw" }} />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            )}
                                                                        </Stack>
                                                                    </TableCell>

                                                                    {/* Celdas con lo gastado consumido en cada estudio */}
                                                                    {estudios.map((est) => {
                                                                        const cantGastada = art.estudiosGastado && art.estudiosGastado[est.idEstudio] !== undefined
                                                                            ? art.estudiosGastado[est.idEstudio]
                                                                            : 0;

                                                                        return (
                                                                            <TableCell key={`${art.idArticulo}-${est.idEstudio}`} align="center">
                                                                                <Typography sx={{ fontSize: "0.9vw", fontWeight: cantGastada > 0 ? "bold" : "normal", color: cantGastada > 0 ? "#0284c7" : "#94a3b8" }}>
                                                                                    {cantGastada}
                                                                                </Typography>
                                                                            </TableCell>
                                                                        );
                                                                    })}
                                                                </TableRow>
                                                            );
                                                        })
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={5 + estudios.length}
                                                                align="center"
                                                                sx={{ py: 5 }}
                                                            >
                                                                <Typography sx={{ fontSize: "1vw", color: "#64748b" }}>
                                                                    No se encontraron artículos en el inventario
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Stack>
                </Box>
            </Content>
        </Layout>
    );
};

export default Inventario;
